<template>
    <div
        :class="{ item: true, active }"
        draggable="true"
        @click.prevent="$emit('click', image)"
        @dragstart="
            (ev) => {
                onDragStartImage(image, ev);
            }
        "
        @dragend="onDragEndImage"
    >
        <v-row no-gutters>
            <v-col class="d-flex justify-start">
                <v-menu offset-y>
                    <template #activator="{ on, attrs }">
                        <v-btn v-bind="attrs" icon x-small plain v-on="on">
                            <KpIcon icon-cls="moredots" color="black" size="16" />
                        </v-btn>
                    </template>

                    <ImageContextMenu
                        :record="image"
                        @delete="$emit('delete', $event)"
                        @duplicate="$emit('duplicate', $event)"
                    />
                </v-menu>
            </v-col>
            <v-col class="d-flex justify-end">
                <v-simple-checkbox
                    v-if="!hideMultiselect"
                    :value="checked"
                    hide-details="auto"
                    class="ma-0 pa-0"
                    :ripple="false"
                    @input="$emit('checked', $event)"
                />
            </v-col>
        </v-row>
        <figure>
            <v-img :src="image.$.thumb_url" :alt="image.$.title || image.$.caption" width="200" height="150" contain />
            <figcaption>
                <div class="img-title">{{ image.$.title }}</div>
                <div class="img-staff_title">{{ image.$.staff_title }}</div>
                <div class="img-caption">{{ image.$.caption }}</div>
                <div class="img-credits">{{ image.$.credits }}</div>
            </figcaption>
        </figure>
    </div>
</template>

<script>
import ImageContextMenu from '@/components/media_manager/ImageContextMenu.vue';
import { Image } from '@/models/Image';
export default {
    name: 'MediaManagerImageCard',
    components: { ImageContextMenu },
    props: {
        active: {
            type: Boolean,
            default: false,
        },
        checked: {
            type: Boolean,
            required: true,
        },
        image: {
            type: Image,
            required: true,
        },
        /** if true, the image's multiselect functions are not shown */
        hideMultiselect: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        onDragStartImage(item, ev) {
            ev.dataTransfer.dropEffect = 'move';
            ev.dataTransfer.setData('text/plain', item.id);
            ev.currentTarget.classList.add('dragging');
        },

        onDragEndImage(ev) {
            ev.currentTarget.classList.remove('dragging');
        },
    },
};
</script>

<style lang="scss" scoped>
.item {
    width: 224px;
    height: 240px;
    flex-shrink: 0;
    border: 2px solid transparent;
    overflow: hidden;
    padding: 0 10px 10px 10px;
    margin-top: 5px;
    background-color: var(--tgk-grey-5);
    border-radius: 4px;

    :hover {
        cursor: pointer;
    }

    &.active {
        background-color: var(--panel-bg-color);
    }

    &.dragging {
        opacity: 0.4;
    }

    a {
        text-decoration-line: none;
    }

    figure {
        figcaption {
            font-size: 0.875rem;
            margin-top: 5px;
            color: var(--gray-text-color);
            text-align: center;
            text-decoration: none;
            text-decoration-line: none;
            .img-title,
            .img-caption,
            .img-staff_title,
            .img-credits {
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }
    }
}
</style>
